<template>
  <div class="feedback-popup__container">
    <section class="feedback-popup__box">
      <!-- <div class="feedback-popup__box feedback-popup__btn-box" :class="[expanded == -1 ? '' : 'feedback-popup__card--fold']"> -->
      <div class="feedback-popup__btn-card">
        <div class="feedback-popup__hover-btn" @click="handleExpanded(1)">
          <img src="@/assets/images/public/online_message.png" alt="" />
          <span class="feedback-popup__hover-btn__label">在线留言</span>
        </div>
        <div class="feedback-popup__hover-btn" @click="handleExpanded(2)">
          <img src="@/assets/images/public/online_consultant.png" alt="" />
          <span class="feedback-popup__hover-btn__label">专属客服</span>
        </div>
        <div class="feedback-popup__hover-btn" @click="openWeCom()">
          <img src="@/assets/images/public/qiteweixin.png" alt="" />
          <span class="feedback-popup__hover-btn__label">在线咨询</span>
        </div>
      </div>

      <div
        v-show="expanded == 1"
        class="feedback-popup__card feedback-popup__card-message"
        :class="[expanded == 1 ? '' : 'feedback-popup__card--fold']"
      >
        <!-- head -->
        <div class="feedback-popup__head">
          <h3 class="feedback-popup__title">
            <span>在线留言</span>
          </h3>
          <div class="feedback-popup__close" @click="handleExpanded(-1)">
            <i class="el-icon-error"></i>
          </div>
        </div>

        <!-- body -->
        <div class="feedback-popup__body">
          <el-form
            :model="leave_form"
            :rules="rules"
            ref="ruleForm"
            class="leave-msg__form"
          >
            <!-- 姓名 -->
            <div class="leave-msg__form-item">
              <el-form-item :label="contactUs.form.usernameLabel" prop="username">
                <el-input placeholder="" v-model="leave_form.username"></el-input>
              </el-form-item>
            </div>
            <!-- 公司 -->
            <div class="leave-msg__form-item">
              <el-form-item :label="contactUs.form.businessLabel" prop="business">
                <el-input placeholder="" v-model="leave_form.business"></el-input>
              </el-form-item>
            </div>
            <!-- 联系电话 -->
            <div class="leave-msg__form-item">
              <el-form-item :label="contactUs.form.telPhoneLabel" prop="tel_phone">
                <el-input placeholder="" v-model="leave_form.tel_phone"></el-input>
              </el-form-item>
            </div>
            <!-- 邮箱 -->
            <div class="leave-msg__form-item">
              <el-form-item :label="contactUs.form.emailLabel" prop="email">
                <el-input placeholder="" v-model="leave_form.email"></el-input>
              </el-form-item>
            </div>
            <!-- 内容 -->
            <div class="leave-msg__form-textarea leave-msg__form-item">
              <el-form-item label="" prop="leave_content">
                <el-input
                  type="textarea"
                  show-word-limit
                  resize="none"
                  :placeholder="contactUs.form.leaveContentPlaceholder"
                  v-model="leave_form.leave_content"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
          <!-- 提交按钮 -->
          <div class="leave-msg__form-submit-btn flex f-column f-center">
            <el-button :loading="isSubmiting" @click="handleFormSubmit('ruleForm')">
              <span>{{ contactUs.form.submitBtn }}</span>
            </el-button>
          </div>
        </div>
      </div>

      <div
        v-show="expanded == 2"
        class="feedback-popup__card feedback-popup__card-contact"
        :class="[expanded == 2 ? '' : 'feedback-popup__card--fold']"
      >
        <!-- head -->
        <div class="feedback-popup__head">
          <h3 class="feedback-popup__title">
            <span>专属客服</span>
          </h3>
          <div class="feedback-popup__close" @click="handleExpanded(-1)">
            <i class="el-icon-error"></i>
          </div>
        </div>

        <!-- body -->
        <div class="feedback-popup__body">
          <ul class="feedback-popup__contact-list">
            <li
              v-for="(item, i) in productCenterPage.onlineMessage.info_list"
              :key="i"
              class="feedback-popup__contact-item"
            >
              <span class="feedback-popup__contact-label">{{
                item.label
              }}</span>
              <span
                class="feedback-popup__contact-value"
                v-html="$convertPxToRem(item.content)"
              ></span>
            </li>
          </ul>
          <div class="qr-code__box">
            <img :src="productCenterPage.onlineMessage.qrcode[0].src" alt="" />
          </div>
        </div>
      </div>
    </section>

    <verification-code ref="verificationCodeRef" @on-submit="handleCodeSubmit"></verification-code>
    <message-success-modal ref="messageSuccessModalRef"></message-success-modal>
  </div>
</template>

<script>
import { storage_key } from "@/config/constant";
import { mapGetters } from "vuex";
import { postAdvise, sendEmail, checkEmailApi } from "@/utils/http.js";
import VerificationCode from '@/pages/callMe/modules/verification_code.vue'
import MessageSuccessModal from '@/pages/callMe/modules/success_modal.vue'

export default {
  components: {
    VerificationCode,
    MessageSuccessModal
  },

  data() {
    return {
      expanded: -1,

      leave_form: {
        username: "",
        business: "",
        tel_phone: "",
        email: "",
        emailCode: "",
        leave_content: ""
      },
      rules: {
        username: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        business: [{ required: true, message: "请输入公司", trigger: "blur" }],
        tel_phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        leave_content: [{ required: true, message: "请输入留言内容", trigger: "blur" }]
      },
      isSubmiting: false,
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    productCenterPage() {
      return this.currentLang.config.productCenterPage;
    },
    contactUs() {
      return this.currentLang.config.contactUs;
    }
  },

  created() {},

  mounted() {},
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    // 悬浮弹框折叠展开回调
    handleExpanded(flag) {
      console.log("flag", flag);
      this.expanded = flag;
    },

    handleFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          checkEmailApi({ email: this.leave_form.email }).then(res => {
            if (res.code === 1) {
              if (res.data) {
                this.submitForm(this.leave_form)
              }
              else {
                this.$refs.verificationCodeRef.open(this.leave_form)
              }
            }
            else {
              this.$message.error(res.msg);
            }
          });
        }
        else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCodeSubmit(formData) {
      this.$refs.verificationCodeRef.isSubmiting = true
      this.submitForm(formData)
    },
    openWeCom() {
      
      const weComUrl = 'https://work.weixin.qq.com/kfid/kfc02a62b31203e7bee';
      // const downloadUrl = 'https://work.weixin.qq.com/';
      
      // // 尝试打开企业微信
      window.location.href = weComUrl;
      
      // // 如果3秒后仍未跳转，则跳转到下载页面
      // this.timer = setTimeout(() => {
      //   window.location.href = downloadUrl;
      // }, 3000);
    },
    // 提交留言
    submitForm(query) {
      this.isSubmiting = true
      const params = {
        type_id: 13,
        content: query.leave_content,
        email: query.email,
        email_code: query.emailCode,
        name: query.username,
        phone: query.tel_phone,
        company_name: query.business
      }

      postAdvise(params).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.$message.success(res.msg);
          this.leave_form = {
            username: "",
            business: "",
            tel_phone: "",
            email: "",
            emailCode: "",
            leave_content: ""
          };
          this.$refs.verificationCodeRef.close()
          this.$refs.messageSuccessModalRef.open(res.data)
        }
      })
      .catch(err => {
        err.msg && this.$message.error(err.msg)
      })
      .finally(() => {
        this.$refs.verificationCodeRef.isSubmiting = false 
        this.isSubmiting = false
      })
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.feedback-popup__box {
  position: fixed;
  right: 0px;
  bottom: 0;
  // z-index: 1;
  display: flex;
  flex-direction: row-reverse;
}

.feedback-popup__head {
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 0px 5px 10px;
  background-color: var(--main-color);

  .feedback-popup__title {
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 2px;
    color: #fff;
  }

  .feedback-popup__close {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 100%;
    cursor: pointer;
    color: #fff;
    font-weight: 300;
    font-size: 20px;
  }
}

.feedback-popup__link-box {
  padding: 8px 10px 5px;
  cursor: pointer;

  .feedback-popup__link {
    padding: 2px 8px;
    background-color: rgba($color: #00a4ff, $alpha: 0.15);
    border: 1px solid #00a4ff;
    border-radius: 5px;
    color: #00a4ff;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 1px;
    text-align: center;
  }
}

.feedback-popup__btn-card {
  display: flex;
  flex-direction: column;
  width: auto;
  height: auto;
  min-height: auto;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  border: 0;
  overflow: hidden;

  .feedback-popup__hover-btn {
    position: relative;
    // width: 100px;
    padding: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-color: var(--main-color);
    background-color:rgba(6, 51, 88 ,.85);
    cursor: pointer;
    color: #fff;

    img {
      width: 20px;
      height: auto;
      margin-bottom: 5px;
    }

    .feedback-popup__hover-btn__label {
      letter-spacing: 2px;
      font-size: 12px;
    }
  }

  .feedback-popup__hover-btn:hover {
    // transform: scale(1.1);
  }

  .feedback-popup__hover-btn::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    height: 1px;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.75);
  }

  .feedback-popup__hover-btn:last-child::after {
    height: 0;
    width: 0;
  }
}

.feedback-popup__card {
// height: 200px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  min-width: 300px;
  min-height: 100px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid var(--main-color);
  // border: 1px solid var(--main-color-blue);
  color: #333;
  position: absolute;
  right: 100%;
  bottom: 0;
}

.feedback-popup__card--fold {
  overflow: hidden !important;
  width: 0 !important;
  min-width: 0 !important;
  border: 0 !important;
  margin: 0 !important;
  // z-index: -1;
}

.feedback-popup__body {
  flex: 1;
  padding: 5px 8px;
  overflow: auto;
  overflow-x: hidden;
  border-radius: 0px 0px 10px 10px;

  .feedback-popup__img {
    width: 100%;
  }

  .feedback-popup__content {
    font-size: 15px;
    color: #555;
    line-height: 1.8;
    font-weight: normal;
  }
}

.feedback-popup__card-contact {
  .feedback-popup__body {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 20px;
  }

  .feedback-popup__contact-list {
    padding: 15px 20px 15px 0;

    .feedback-popup__contact-item {
      margin-bottom: 10px;
      font-size: 17px;
    }
  }

  .qr-code__box {
    width: 120px;
    height: 120px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}



.feedback-popup__card-message {

  .feedback-popup__body {
    padding: 15px;
    // max-height: 450px;
  }

  .leave-msg__form {

    .leave-msg__form-item {
      width: 48%;
      width: 100%;
      margin-bottom: 12px;
      border: 2px solid #dfdfdf;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      .el-form-item {
        width: 100%;
        margin-bottom: 0;
        display: flex;
      }
      /deep/ .el-form-item__label {
        padding: 0 10px !important;
        white-space: nowrap;
      }
      /deep/ .el-form-item__content {
        position: relative;
        font-size: 14px;
        width: 100%;
      }
      .leave-msg__form-item-block {
        display: flex;
        align-items: center;
      }
      .getCode_btn {
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;
      }
    }

    .leave-msg__form-textarea {
      width: 100%;
      margin-bottom: 20px;
    }
    /deep/ .el-input-group__prepend {
      background-color: #fff;
      border: 0;
      border-radius: 0;
      color: #606266;
    }

    /deep/ .el-input__inner {
      border: 0;
      border-radius: 0;
      height: 36px;
      line-height: 36px;
      display: block;
    }

    /deep/ .el-textarea__inner {
      border: 0;
      border-radius: 0;
      height: calc(150px - 4px);
    }
    /deep/ .el-upload-list__item {
      line-height: normal;
      margin-left: 10px;
      margin-top: 0px !important;
    }
    /deep/ .el-upload__tip {
      font-size: 12px;
      color: #606266;
      margin-top: 7px;
      position: absolute;
      bottom: -34px;
    }
  }

  .leave-msg__form-submit-btn {
    /deep/ .el-button {
      width: 120px;
      height: 46px;
      margin-bottom: 5px;
      border: 0;
      border-radius: 8px;
      background-color: #003359;
      color: #fff;
      font-size: 16px;
      letter-spacing: 2px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/feedbackPopup.vue